<template>
  <v-flex data-qa="savings-flex-det9qa">
    <Loader v-show="loaderEnabled"/>
    <v-layout wrap class="ml-2 pt-0" data-qa="savings-layout-w4az5">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient }"
       data-qa="savings-flex-agflom">
        <v-container data-qa="savings-container-0r4hfj">
          <v-flex xs12 sm12 md12 lg12 xl12 class="px-2" data-qa="savings-flex-d6to9r">
            <v-flex xs12 sm10 md10 lg8 xl7 data-qa="savings-flex-q23ah9">
              <v-row no-gutters class="pb-2" data-qa="savings-row-x8nsy5">
                  <inline-svg
                    class="mt-2"
                    :src="getNavigationIcon()"
                    width="50"
                    height="50"
                    aria-label="Navigation Icon"
                  ></inline-svg>
                  <font class="display-1 font-weight-thin white--text pt-4 pl-2">
                    {{savingsTitle}} <font v-if="showTotalAccountsAvailable">({{ savingsAccount.accounts.length }})</font>
                  </font>
              </v-row>
            </v-flex>
            <v-row class="px-2 pl-6 py-2" data-qa="savings-row-edy05">
              <v-layout row wrap v-if="showTotalBalance && !isMultiCurrency" data-qa="savings-layout-fftzvd">
                <v-flex xs12 sm12 md12 lg12 xl12 class="px-1" data-qa="savings-flex-56nss">
                  <font class="subheading-1 font-weight-medium white--text">{{
                    $t("accountDetails.totalBalance")
                  }}</font>
                </v-flex>
                <v-flex xs12 sm12 md12 lg12 xl12 class="px-1" data-qa="savings-flex-wdq0me">
                  <font class="text-h5 font-weight-bold white--text">{{
                    $formatter.currency.format(accDetails.myBalance, accDetails.currency)
                  }}</font>
                </v-flex>
              </v-layout>

              <v-layout v-if="enableOpenNewAccountOption" class="py-2" data-qa="savings-layout-lm5465">
                <v-flex sm12 xs12 md12 lg12 xl12 class="text-right" data-qa="savings-flex-cf02io">
                  <v-btn
                    @click="goToOffer('SVGS')"
                    color="white"
                    class="text-none py-2 px-4"
                    outlined
                     data-qa="savings-btn-tdi2ue">{{$t("common.openNewAccountLabel")}}</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex xs12 sm12 md12 lg9 xl9 class="pl-1 mt-4" data-qa="savings-flex-k25bgh">
      <CardLayout :config="savingsAccount" />
    </v-flex>
  </v-flex>
</template>

<script>
import _ from 'lodash'
import preload from '@/util/preload'
import store from '@/core/store'
import event from '@/util/event'
import CardLayout from '@/views/home/HomeCards.vue'
import Loader from '../../components/common/Loader.vue'

export default {
  name: 'Savings',
  components: {
    Loader,
    CardLayout
  },
  data () {
    return {
      accountType: 'SVGS',
      loaderEnabled: false,
      savingsAccount: {
        title: this.$t('common.savingsTypeLabel'),
        cardLabels: false,
        openNewACCard: false,
        enableShowMore: false,
        accounts: []
      },
      accDetails: {
        myBalance: 0,
        currency: '',
        series: []
      },
      baseCurrency: this.$appSettings.defaultConfigurations.currencyFormat.currency,
      enableOpenNewAccountOption: this.$appSettings.defaultConfigurations.enableOpenNewAccountOption,
      showTotalBalance: this.$appSettings.defaultConfigurations.totalBalanceSection.enableSavingsSection,
      showTotalAccountsAvailable: this.$appSettings.defaultConfigurations.showTotalAccountsAvailable.enableSavingsSection,
      viewClosedAccountsList: this.$appSettings.defaultConfigurations.viewClosedAccountsList,
      excludedAccountStatus: this.$appSettings.uiFieldsDisplayConfigurations.casaAccountListing.exclusionList,
      enableUkMarketSavingAccInDashboard: this.$appSettings.defaultConfigurations.landingPageConfig.enableUkMarketSavingAccInDashboard,
      ukMarketSavingsGrouping: this.$appSettings.defaultConfigurations.landingPageConfig.ukMarketSavingsGrouping,
      isMultiCurrency: false,
      savingsTitle: '',
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess
    }
  },
  beforeCreate () {
    if (this.$route.params.reload) {
      location.reload()
    }
  },
  created () {
    // Fetch Permissions for SME Users
    this.permissions = store.getters['profileStore/profileData']?.permissions
    this.savingsTitle = this.$appSettings.defaultConfigurations.landingPageConfig.enableUkMarketSavingAccInDashboard
      ? this.$t('common.savingsSubTitle_1')
      : this.$t('common.savingsLabel')
    if (this.$route.params && this.$route.params.from === 'Dashboard') {
      this.savingsAccount.enableShowMore = true
    } else this.savingsAccount.enableShowMore = false
    // const exclusionList = this.$appSettings.uiFieldsDisplayConfigurations
    //   .tableColumns.accountListTables.exclusionList
    event.$on('set_myAccounts', () => {
      // this.fetchAccounts()
      this.getListOfAccounts()
      this.loaderEnabled = false
    })
    if (this.ifMyAccountsAvailable()) {
      // this.fetchAccounts()
      this.getListOfAccounts()
    } else {
      this.loaderEnabled = true
      preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
    }
  },
  methods: {
    getNavigationIcon () {
      return this.getSvgIconSrc('Savings_1')
    },
    goToOffer (type) {
      this.$router.push({
        name: 'Savings Products',
        params: { accountType: type }
      })
    },
    getListOfAccounts () {
      this.loaderEnabled = true
      const data = store.getters['userStore/userData'].myAccounts
      if (data) {
        this.savingsAccount.accounts = data.savingAccounts
          ? data.savingAccounts.accountList
          : []
        if (this.savingsAccount.accounts.length) {
          this.savingsAccount.accounts = _.filter(this.savingsAccount.accounts,
            account => {
              if (this.viewClosedAccountsList.includes(account.accountType) && account.accountStatus === 'CLOSED') {
                return account
              } else return !(this.excludedAccountStatus.includes(account.accountStatus))
            })
          // TODO this.savingsAccount.accounts.forEach((key, index) => {
          //   if (key.currency !== this.baseCurrency) {
          //     this.isMultiCurrency = true
          //   }
          // })
          if (this.enableUkMarketSavingAccInDashboard) {
            const filteredSvgsAcc = []
            this.savingsAccount.accounts.forEach((svgsAcc) => {
              if (this.ukMarketSavingsGrouping[0].accType.includes(svgsAcc.accountType)) {
                filteredSvgsAcc.push(svgsAcc)
              }
            })
            this.savingsAccount.accounts = [...filteredSvgsAcc]
          }
          if (this.isSmeLogin && this.enableRoleBasedAccess) {
            if (!this.permissions?.includes('NOTICE_VIEW_DETAILS')) {
              this.savingsAccount.accounts = this.savingsAccount?.accounts?.filter((account) => {
                return account?.accountType !== 'NACC'
              })
            }
            if (!this.permissions?.includes('SAVING_VIEW_DETAILS')) {
              this.savingsAccount.accounts = this.savingsAccount?.accounts?.filter((account) => {
                return account?.accountType !== 'SVGS'
              })
            }
          }
        }
        for (const i in data) {
          if (data[i].accountList[0]) {
            this.accDetails.currency = data[i].accountList[0].currency
          }
          switch (data[i].label) {
            case 'savingAccounts':
              this.accDetails.series.push(data[i].totalSavingBalance)
              this.accDetails.myBalance += data[i].totalSavingBalance
              break
            default:
              break
          }
        }
      }
      this.loaderEnabled = false
    },
    fetchAccounts () {
      this.loaderEnabled = true
      const accounts = store.getters['userStore/userData'].myAccounts
      const savingsAccounts = accounts.savingAccounts
        ? accounts.savingAccounts.accountList
        : []
      if (savingsAccounts && savingsAccounts.length) {
        this.savingsAccount.accounts = []
        const excludeAccountStatus = ['BLOCKED', 'STOPPED']
        for (const i in savingsAccounts) {
          if (excludeAccountStatus.includes(savingsAccounts[i].accountStatus)) {
            savingsAccounts[i].balance = this.$t(
              'myAccounts.notAvailableLabel'
            )
          } else {
            if (!isNaN(savingsAccounts[i].balance)) {
              savingsAccounts[i].balance = this.getBalInfo(
                savingsAccounts[i].balance
              )
            } else {
              if (
                !savingsAccounts[i].balance &&
                savingsAccounts[i].accountStatus === 'ACTIVATED'
              ) {
                savingsAccounts[i].balance = this.$t(
                  'myAccounts.balanceInquiryRestricted'
                )
              }
            }
          }
          this.savingsAccount.accounts.push({
            ...savingsAccounts[i],
            status: this.$t(
              `systemEnums.casa.${savingsAccounts[i].accountStatus}`
            ),
            accountNumber: savingsAccounts[i].accountId
          })
        }
        this.loaderEnabled = false
      } else {
        this.loaderEnabled = false
      }
    },
    ifMyAccountsAvailable () {
      return store.getters['userStore/userData'].myAccounts
    },
    getBalInfo (bal) {
      if (bal !== undefined && bal.toString().trim().length > 0) {
        if (isNaN(bal)) {
          return bal
        } else {
          return this.$formatter.currency.format(bal)
        }
      } else {
        return this.$t('myAccounts.notAvailableLabel')
      }
    }
  }
}
</script>
